import { useUpdateHabitStatisticsTimeframeMutation } from 'shared/hooks/queries/use-update-habit-statistics-timeframe-mutation';

export const useUpdateHabitStatisticsTimeframe = () => {
  const { mutate } = useUpdateHabitStatisticsTimeframeMutation();

  return mutate;
};
